// MetricModal "Değişim kolonu varsayılanı" (+ artış yönü) ve "Varsayılan form sorusu kodu"
// alanları (MetricModal 600 satır sınırı — salt taşıma).

import { type MetricDraft } from "../../lib/kpi-metric-draft";
import {
  KPI_INCREASE_OPTIONS,
  btnSmall,
  fieldStyle,
  increaseToOption,
  inputStyle,
  labelStyle,
  monoStyle,
  optionToIncrease,
} from "./kpi-form-styles";

export interface MetricModalDefaultsProps {
  draft: MetricDraft;
  disabled: boolean;
  set: <K extends keyof MetricDraft>(k: K, v: MetricDraft[K]) => void;
}

export function MetricModalDefaults(props: MetricModalDefaultsProps): JSX.Element {
  const { draft, set } = props;
  const dis = props.disabled;
  return (
    <>
      <div style={fieldStyle}>
        <span style={labelStyle}>Değişim kolonu varsayılanı</span>
        <label
          className="flex items-center gap-2 text-sm"
          style={{ color: "var(--color-text)", minHeight: 32 }}
        >
          <input
            type="checkbox"
            checked={draft.showChangeDefault}
            disabled={dis}
            onChange={(e) => set("showChangeDefault", e.target.checked)}
          />
          Veri setlerinde varsayılan olarak göster
        </label>
        <div role="radiogroup" aria-label="Artış yönü varsayılanı" className="flex gap-1 flex-wrap">
          <span className="text-sm" style={{ color: "var(--color-text-3)", marginRight: 4 }}>
            Artış:
          </span>
          {KPI_INCREASE_OPTIONS.map((o) => {
            const on = increaseToOption(draft.increaseIsGoodDefault) === o.value;
            return (
              <button
                key={o.value}
                type="button"
                role="radio"
                aria-checked={on}
                disabled={dis}
                onClick={() => set("increaseIsGoodDefault", optionToIncrease(o.value))}
                style={{
                  ...btnSmall,
                  ...(on
                    ? {
                        background: "var(--color-primary)",
                        color: "var(--color-surface)",
                        borderColor: "var(--color-primary)",
                      }
                    : {}),
                }}
              >
                {o.label}
              </button>
            );
          })}
        </div>
      </div>
      <div style={fieldStyle}>
        <label style={labelStyle} htmlFor="m-q">
          Varsayılan form sorusu kodu
        </label>
        <input
          id="m-q"
          style={{ ...inputStyle, ...monoStyle }}
          value={draft.defaultQuestionCode}
          disabled={dis}
          maxLength={64}
          onChange={(e) => set("defaultQuestionCode", e.target.value)}
        />
      </div>
    </>
  );
}
